import * as Sentry from "@sentry/react";

import { type ErrorTrackingService } from "@fitness-app/data-models/domain/services/ErrorTrackingService";

export class SentryErrorTrackingService implements ErrorTrackingService {
  private isLocalhost: boolean = window.location.hostname === "localhost";

  init(userId?: string, userProperties?: Record<string, string>): void {
    if (this.isLocalhost) {
      return;
    }

    Sentry.setUser({
      id: userId || "",
      email: userProperties?.email,
      username: userProperties?.name,
    });

    if (userProperties) {
      Object.entries(userProperties).forEach(([key, value]) => {
        if (key !== "email" && key !== "name") {
          Sentry.setTag(key, value);
        }
      });
    }
  }

  recordError(error: Error | unknown, context?: string, extra?: Record<string, unknown>): void {
    if (this.isLocalhost) {
      // eslint-disable-next-line no-console
      console.log(`Log error to sentry: ${error}`);
    }
    const isError = error instanceof Error;
    // @ts-expect-error ignore
    Sentry.captureException(isError ? error : new Error(String("message" in error ? error.message : "Unknown error")), {
      extra: context ? { ...extra, action: context, error } : undefined,
    });
  }

  log(message: string): void {
    if (this.isLocalhost) {
      // eslint-disable-next-line no-console
      console.log(`Log to sentry: ${message}`);
    }
    Sentry.logger.info(message);
  }

  setAttributes(attributes: Record<string, string>): void {
    if (this.isLocalhost) {
      // eslint-disable-next-line no-console
      console.log(`Set attributes to sentry: ${JSON.stringify(attributes)}`);
    }
    Object.entries(attributes).forEach(([key, value]) => {
      Sentry.setTag(key, value);
    });
  }
}

export const sentryErrorTrackingService = new SentryErrorTrackingService();
